// extracted by mini-css-extract-plugin
export default {"container":"Competitors_container__YmVUf","title":"Competitors_title__pW8FU","card":"Competitors_card__tOBFP","error":"Competitors_error__ldnvL"};